import axios from "axios";
import { getVoiceApi } from "./config.service";

const getToken = () => {
    if (localStorage.getItem('TOKEN')) {

        return {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('TOKEN')
            }
        }
    }

    return {};
}
export const getUserName = () => {
    const data = localStorage.getItem('user');
    if (data) {
        return JSON.parse(data)?.username;
    }
    return '';
}

// Request interceptor to dynamically add JWT token to requests
const addAuthInterceptor = (instance) => {
    instance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('TOKEN');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response interceptor to handle 401 unauthorized errors
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                localStorage.removeItem('TOKEN');
                localStorage.removeItem('user');
                window.location.href = '/?error=unauthorized';
            }
            return Promise.reject(error);
        }
    );

    return instance;
};

// Login service - no auth interceptor needed (used before login)
export const loginService = axios.create({
    baseURL: getVoiceApi(),
    timeout: 30000,
});

// SSO API service - no auth interceptor (used during Cognito callback)
export const ssoApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/v1', ''),
    timeout: 30000,
});

// Default service with auth interceptor
const lensService = axios.create({
    baseURL: getVoiceApi(),
    timeout: 30000,
});
addAuthInterceptor(lensService);
export default lensService;

// Jira API service with auth interceptor
export const JiraApi = axios.create({
    baseURL: getVoiceApi(),
    timeout: 30000,
});
addAuthInterceptor(JiraApi);

// External API service (no auth needed)
export const acApi = axios.create({
    baseURL: `https://api.tekvision.com`,
    timeout: 30000,
});